jQuery(document).ready(function($) {
    $('.tape-trigger').on('click', function(e) {
        e.preventDefault();
        var tapeClass = $(this).data('tape-trigger');
        $('#bb-video-player .bb-video').hide();
        $('#bb-video-player .' + tapeClass).show();
    });
});